import type {
  ChannelThreadId,
  SupportTicketId,
} from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface MobileMessageThreadViewProps {
  messages: Message[];
  messageThreadIds?: readonly ChannelThreadId[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const MobileMessageThreadView = memo(function MobileMessageThreadView({
  messages,
  messageThreadIds,
  supportTicketId,
  thread,
}: MobileMessageThreadViewProps) {
  return (
    <ChatThreadView
      allowReplies={false}
      channel="mobileMessage"
      messages={messages}
      messageThreadIds={messageThreadIds}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
